export const base_headersMultipart = {
    "Client-Type": "web",
    Accept: "application/json",
    "App-Key": sessionStorage.getItem("app_key") || "master",
    "Auth-Token": localStorage.getItem("token"),
    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
    Pragma: "no-cache",
    Expires: "0",
    "ngrok-skip-browser-warning": 123,
    "Content-Type": "multipart/form-data",
    "Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
}

export const base_headers = {
    "Client-Type": "web",
    Accept: "application/json",
    "App-Key": sessionStorage.getItem("app_key") || "master",
    "Auth-Token": localStorage.getItem("token"),
    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
    Pragma: "no-cache",
    Expires: "0",
    "ngrok-skip-browser-warning": 123,
    "Content-Type": "application/json",
    "Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
}
// Always return latest App-Key
Object.defineProperty(base_headers, "App-Key", {
    configurable: true,
    enumerable: true,
    get() {
        return sessionStorage.getItem("app_key") || "master"
    },
})

// Always return latest Auth-Token
Object.defineProperty(base_headers, "Auth-Token", {
    configurable: true,
    enumerable: true,
    get() {
        return localStorage.getItem("token")
    },
})

export const formatRoleName = (name) => {
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return ""
        if (typeof value === "string") return value
        if (typeof value === "number" || typeof value === "boolean" || typeof value === "bigint") {
            return String(value)
        }
        if (Array.isArray(value)) {
            return value.map((item) => normalizeValue(item)).filter(Boolean).join(", ")
        }
        if (typeof value === "object") {
            const candidate =
                value.name ?? value.label ?? value.category_name ?? value.title ?? value.value
            return normalizeValue(candidate)
        }
        return String(value)
    }

    const normalizedName = normalizeValue(name)

    return normalizedName
        ?.split("_")
        ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        ?.join(" ")
}
